import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	followUpDropdown: {
		marginLeft: 8,
		width: 150,
	},
	sendFromDropdownContainer: {
		alignItems: 'center',
		color: darkGrayFontColor,
		display: 'flex',
		flex: 1,
		fontSize: 14,
		marginLeft: 25,
		marginTop: 8,
		width: '50%',
	},
});
